module.exports = __webpack_public_path__ + "static/img/Liam-Ison.134f85d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Liam-Ison.jpg
// module id = ixD4
// module chunks = 0